module.exports = __webpack_public_path__ + "media/images/landing/icon-add-to-cart-bd095fd7df84396974613ec3ac8161e7.svg";